export default __webpack_public_path__ + "static/media/grafema_amcc_08.fa9f0c36.jpg";